import { useCallback, useState } from 'react';
import { assistantGroupOnlineStatus } from 'services/api/assistant';

/** 查询客服组在线状态列表 */
export default function useAssistantGroup() {
  const [assistantGroup, setAssistantGroup] = useState<Assistant.AssistantGroupOnlineStatusInfo[]>(
    [],
  );
  const fetchAssistantGroup = useCallback(() => {
    return assistantGroupOnlineStatus()
      .then((res) => {
        setAssistantGroup(res);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }, [setAssistantGroup]);

  return {
    assistantGroup,
    fetchAssistantGroup,
  };
}
